import { render, staticRenderFns } from "./PolicyDocument.vue?vue&type=template&id=d6d2c7b6&"
import script from "./PolicyDocument.vue?vue&type=script&lang=ts&"
export * from "./PolicyDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports